import {Injectable} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {AngularFireStorage} from '@angular/fire/storage';
import {AuthService} from '../shared/auth/auth.service';
import {Observable, pipe, Subject} from 'rxjs/Rx';
import {concatMap, map, tap} from 'rxjs/operators';
import {UserModel} from '../_models/_firebaseObjects/UserModel';
import {WorkoutEventModel} from '../_models/_firebaseObjects/WorkoutEventModel';
import {UserReport} from '../_models/_firebaseObjects/UserReport';
import {observable} from 'rxjs/internal-compatibility';
import {of} from 'rxjs/internal/observable/of';
import {User} from 'firebase';

@Injectable()
export class AdminService {
  user_uid: string;
  startAt$ = new Subject<number>();

  //endAt$ = new Subject<number>();

  constructor(public db: AngularFireDatabase, private storage: AngularFireStorage, private authService: AuthService) {
    this.user_uid = localStorage.getItem('user_uid');
  }

  getUserDetails(): Observable<{}> {
    this.user_uid = localStorage.getItem('user_uid');
    return this.db.object('users/' + this.user_uid).valueChanges();
    //return this.db.object('users/' + localStorage.getItem('user_id')).valueChanges();
  }

  getAllGyms(): Observable<{}> {
    return this.db.list('gyms', ref => ref.orderByChild('Gym Name')).valueChanges();
  }

  getAllMembersCountForGym(gymID: string): Observable<number> {
    return this.db.list('users', ref => ref.orderByChild('chosenGym').equalTo(gymID)).valueChanges().pipe(map((users: UserModel[]) => {
      //console.log('all members: ');
      //console.log(users);
      return users.length;
    }));
  }

  getAllFeaturedEventsCountForGym(gymID: string): Observable<number> {
    return this.db.list('workouts/' + gymID).valueChanges().pipe(map((workouts: WorkoutEventModel[]) => {
      let featured = workouts.filter(x => x.featured).length;
      //console.log('---featured---');
      //console.log(featured);
      return featured;
    }))
  }

  updateGymActiveStatus(gymId: string, active: boolean): Promise<void> {
    let valueToUpdate = active ? 1 : 0;
    return this.db.object('gyms/' + gymId).update({
      'active': valueToUpdate
    });
  }

  getUserDetailsById(userId: string): Observable<UserModel> {
    return this.db.object('users/' + userId).valueChanges().pipe(map((user: UserModel) => user));
  }


  fetchUserReports(): Observable<UserReport[]> {
    let userReports = [];
    return this.db.list('userReports', ref => ref.orderByChild('reason')).valueChanges().pipe(map((reports: any) => {
      //console.log(reports);
      reports.forEach(r => {
        let rep = new UserReport();
        rep.reason = r.reason;
        this.getUserDetailsById(r.reportedUser).subscribe(user => {
          rep.reportedUser = user;
          //console.log(user);
          this.getUserDetailsById(r.reportingUser).subscribe(u => {
            rep.reportingUser = u;
            userReports.push(rep);
          })
        })
      })
      return userReports;
    }))
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/admin.service.ts